// extracted by mini-css-extract-plugin
export var button = "addToCartButton-module--button--SOC+D";
export var ajouter = "addToCartButton-module--ajouter--yKYNe";